import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

const MAIN_URL = 'https://kaspreadsheet.com';

const ABOUT_IMG =
  'https://readdy.ai/api/search-image?query=Stylish%20young%20woman%20in%20trendy%20streetwear%20holding%20a%20shopping%20bag%20of%20luxury%20brands%20walking%20in%20a%20European%20city%20cobblestone%20street%20warm%20golden%20hour%20sunlight%20editorial%20fashion%20photography%20vibrant%20colors%20premium%20lifestyle%20aesthetic&width=900&height=720&seq=achb-about-v3&orientation=portrait&nocache=true';

export default function AboutSection() {
  const { t } = useTranslation();

  return (
    <section id="about" className="py-20 md:py-28 bg-background-100">
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <div className="flex flex-col lg:flex-row items-center gap-12 lg:gap-16">
          <div className="lg:w-1/2 w-full">
            <div className="relative overflow-hidden rounded-2xl">
              <img
                src={ABOUT_IMG}
                alt="AllChinaBuy spreadsheet finds — premium shopping companion"
                title="AllChinaBuy Spreadsheet Finds — Premium Shopping Companion"
                className="w-full h-auto object-cover"
              />
            </div>
          </div>
          <div className="lg:w-1/2 w-full">
            <span className="inline-block px-3 py-1.5 rounded-full bg-accent-100 text-accent-700 text-xs font-semibold tracking-wide mb-5">
              {t('home_about.badge')}
            </span>
            <h2 className="font-heading text-3xl md:text-4xl font-semibold text-foreground-900 leading-tight mb-6 whitespace-pre-line">
              {t('home_about.title')}
            </h2>
            <div className="space-y-4 text-foreground-600 text-sm md:text-base leading-relaxed">
              <p>
                {t('home_about.p1').split('AllChinaBuy spreadsheet').map((part, i, arr) =>
                  i < arr.length - 1 ? (
                    <span key={i}>
                      {part}
                      <strong className="text-foreground-900">AllChinaBuy spreadsheet</strong>
                    </span>
                  ) : (
                    <span key={i}>{part}</span>
                  )
                )}
              </p>
              <p>
                {t('home_about.p2').split('AllChinaBuy spreadsheet 2026').map((part, i, arr) =>
                  i < arr.length - 1 ? (
                    <span key={i}>
                      {part}
                      <strong className="text-foreground-900">AllChinaBuy spreadsheet 2026</strong>
                    </span>
                  ) : (
                    <span key={i}>{part}</span>
                  )
                )}
              </p>
              <p>{t('home_about.p3')}</p>
            </div>
            <div className="mt-8 flex flex-col sm:flex-row gap-4">
              <a
                href={MAIN_URL}
                target="_blank"
                rel="noopener nofollow"
                className="inline-flex items-center justify-between px-6 py-3 rounded-xl bg-foreground-900 text-white font-medium text-sm hover:bg-foreground-800 transition-colors duration-200 whitespace-nowrap cursor-pointer"
              >
                {t('home_about.cta1')}
                <i className="ri-arrow-right-up-line ml-2"></i>
              </a>
              <Link
                to="/allchinabuy-spreadsheet-guide"
                className="inline-flex items-center justify-center px-6 py-3 rounded-xl border border-foreground-200 text-foreground-800 font-medium text-sm hover:bg-foreground-50 transition-colors duration-200 whitespace-nowrap cursor-pointer"
              >
                {t('home_about.cta2')}
                <i className="ri-arrow-right-line ml-2"></i>
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}